class BridgeConnection {
  constructor() {
    this.bridgeUrl = null;
    this.testUrl = '/bridge-status';

    /*
     * Fetch the RTI Bridge URL at runtime. This is awful, but it was the
     * only way I was able to get webpack and Vue to play nicely with standard
     * runtime configuration mechanisms. Webpack makes this extremely difficult.
     *
     * We generate the bridge-url.json file at runtime. Then we have the browser
     * fetch it and load it, then finally set the value of the bridgeUrl variable
     * at runtime.
     *
     * This is terrible for performance, since it is a synchronous HTTP request
     * as part of loading the Javascript for the page.
     */
    let that = this;
    let xhr = new XMLHttpRequest();

    xhr.onError = function() {
      console.error('ERROR: unable to fetch runtime configuration: ' + xhr.statusText);
    };

    xhr.open('GET', '/bridge-url.json', false);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onload = function() {
      let jsonResponse = JSON.parse(this.responseText);
      that.bridgeUrl = jsonResponse.BRIDGE_URL;
    };

    xhr.send();
  }

  isConnected(callback) {
    let that = this;
    let xhr = new XMLHttpRequest();

    xhr.onerror = function() {
      callback(false);
    };

    xhr.open('GET', that.bridgeUrl + that.testUrl, true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onload = function() {
      let jsonResponse = JSON.parse(this.responseText);

      callback(jsonResponse.bridgeStatus === 'available');
    };

    xhr.send();
  }
}

class CameraConnection {
  constructor(url) {
    this.url = url;
  }

  isConnected(callback) {
    let xhr = new XMLHttpRequest();
    xhr.open('GET', this.url, true);
    xhr.onprogress = function() {
      callback(true);
    };
    xhr.onerror = function() {
      callback(false);
    };
    xhr.onloadend = function() {
      console.log('status ' + xhr.status);
      if (xhr.status === 200) {
        callback(true);
      } else {
        callback(false);
      }
    };

    xhr.send();
  }
}

function sexagesimalRaToDecimal(ra) {
  // algorithm: ra_decimal = 15 * ( hh + mm/60 + ss/(60 * 60) )
  /*                 (    hh     ):(     mm            ):  (   ss  ) */
  if (!isNaN(ra)) {
    return ra;
  }
  if (typeof ra === 'string') {
    let m = ra.match('^([0-9]?[0-9])[: ]([0-5]?[0-9][.0-9]*)[: ]?([.0-9]+)?$');
    if (m) {
      let hh = parseInt(m[1], 10);
      let mm = parseFloat(m[2]);
      let ss = m[3] ? parseFloat(m[3]) : 0.0;
      if (hh >= 0 && hh <= 23 && mm >= 0 && mm < 60 && ss >= 0 && ss < 60) {
        ra = (15.0 * (hh + mm / 60.0 + ss / (3600.0))).toFixed(10);
      }
      return ra;
    } else
      return null;
  }
}

function sexagesimalDecToDecimal(dec) {
  // algorithm: dec_decimal = sign * ( dd + mm/60 + ss/(60 * 60) )
  /*                  ( +/-   ) (    dd     ):(     mm            ): (   ss   ) */
  if (!isNaN(dec)) {
    return dec;
  }
  if (typeof dec === 'string') {
    let m = dec.match('^([+-])?([0-9]?[0-9])[: ]([0-5]?[0-9][.0-9]*)[: ]?([.0-9]+)?$');
    if (m) {
      let sign = m[1] === '-' ? -1 : 1;
      let dd = parseInt(m[2], 10);
      let mm = parseFloat(m[3]);
      let ss = m[4] ? parseFloat(m[4]) : 0.0;
      if (dd >= 0 && dd <= 90 && mm >= 0 && mm <= 59 && ss >= 0 && ss < 60) {
        dec = (sign * (dd + mm / 60.0 + ss / 3600.0)).toFixed(10);
      }
      return dec;
    } else
      return null;
  }
}

/**
 * Returns sexigesimal representation of a Declination given in decimal degrees.
 * @param {Number} dec: Declination in decimal degrees.
 * @returns {String} Sexagesimal representation, sDD:MM:SS.s.
 */
function decimalDecToSexagesimal(dec) {
  if (typeof dec === 'number') {
    let sign = '';
    if (dec < 0) {
      dec *= -1;
      sign += '-';
    }
    let degree = Math.floor(dec);
    let leftoverMinutes = (dec % 1) * 60;
    let minute = Math.floor((dec % 1) * 60);
    let second = (leftoverMinutes * 60 % 60).toFixed(1);
    let ms = second.split('.')[1];
    second = second.split('.')[0];

    if (Number(second) === 60) {
      // 60 seconds should tick over to one minute
      second = 0;
      minute++;
    }

    return sign +
      padSingleDigit(degree) + ':' +
      padSingleDigit(minute) + ':' +
      padSingleDigit(second) + '.' + ms;
  }
  return dec;
}

/**
 * Returns sexigesimal representation of a Right Ascension given in decimal degrees.
 * @param {Number} ra: Right Ascension in decimal degrees.
 * @returns {String} Sexagesimal representation, HH:MM:SS.s.
 */
function decimalRaToSexagesimal(ra) {
  if (typeof ra === 'number') {
    if (ra===360) {
      // 360 degrees should be represented as 0 degrees.
      ra = 0;
    }
    let hour = Math.floor(ra / 15);
    let leftoverInMinutes = (ra % 15) / 15 * 60;
    let minute = Math.floor((ra % 15) / 15 * 60);
    let second = (leftoverInMinutes * 60 % 60).toFixed(1);
    let ms = second.split('.')[1];
    second = second.split('.')[0];

    return padSingleDigit(hour) + ':' +
      padSingleDigit(minute) + ':' +
      padSingleDigit(second) + '.' + ms;
  }
  return ra;
}

function padSingleDigit(digit) {
  let s = '';
  if (('' + digit).length === 1) {
    s = s + '0' + digit;
  } else {
    s = s + digit;
  }
  return s;
}

const filterDisplayToActual = {
  'Blue': 'B',
  'Green': 'V',
  'Red': 'rp'
};
Object.freeze(filterDisplayToActual);

const filterActualToDisplay = {
  'gp': 'Blue',
  'rp': 'Green',
  'ip': 'Red'
};
Object.freeze(filterActualToDisplay);

const bridgeConnection = new BridgeConnection();

function initValidation(elementId) {
  (function() {
    'use strict';
    let form = document.getElementById(elementId);
    form.addEventListener('submit', function(event) {
      if (form.checkValidity() === false) {
        event.preventDefault();
        event.stopPropagation();
      }
      form.classList.add('was-validated');
    }, false);
  }());
}

const siteStates = {
  AVAILABLE: 'Available',
  SUN_UP: 'Sun up',
  TECHNICAL_FAILURE: 'Unavailable for technical reasons',
  BAD_WEATHER: 'Closed for bad weather',
  MAINTENANCE: 'Closed for maintenance'
};
Object.freeze(siteStates);

const telescopeStates = {
  STOPPED: 'Stopped',
  TRACKING: 'Tracking',
  NEW_SOURCE: 'New source',
  MOVING_TO_TARGET: 'Moving to target',
  STOPPING: 'Stopping'
};
Object.freeze(telescopeStates);

const cameraStates = {
  IDLE: 'Idle',
  EXPOSING: 'Exposing',
  READING_OUT: 'Reading out',
  CONFIGURING: 'Configuring',
  STOPPING: 'Stopping Camera',
  INIT: 'Init'
};
Object.freeze(cameraStates);

const progressStates = {
  READY: 'Ready',
  PROCESSING: 'Processing',
  EXECUTING: 'Executing request',
  ERROR: 'Error on last observation'
};
Object.freeze(progressStates);

export {
  bridgeConnection,
  CameraConnection,
  decimalDecToSexagesimal,
  decimalRaToSexagesimal,
  sexagesimalDecToDecimal,
  sexagesimalRaToDecimal,
  filterDisplayToActual,
  filterActualToDisplay,
  initValidation,
  siteStates,
  telescopeStates,
  cameraStates,
  progressStates
};

